import io from "socket.io-client";
import {TokenService} from "./token.service";

// Realtime-уведомления (колокольчик). Сервер — export-back/chat/server.js (socket.io 1.7),
// пуш шлёт cron app:notify: событие notify:unread_count без данных, клиент сам перечитывает notification/unread.
const RtService = {
	socket: null as any,
	userId: null as number | null,

	connect(onUnread: () => void) {
		const url = process.env.VUE_APP_RT_URL
		const user = TokenService.getUserObj()
		const token = TokenService.getAccessToken()
		if(!url || !user || !user.id || !token) {
			return
		}
		if(this.socket && this.userId === user.id) {
			return
		}
		this.disconnect()

		this.userId = user.id
		this.socket = io(url, {
			transports: ['websocket'],
			reconnectionDelay: 5000,
			reconnectionDelayMax: 60000
		})
		// connect приходит и после каждого переподключения — сервер забывает авторизацию вместе с сокетом
		this.socket.on('connect', () => {
			const currentToken = TokenService.getAccessToken()
			if(!currentToken) {
				this.disconnect()
				return
			}
			this.socket.emit('auth', {user: this.userId, token: currentToken, expires: 0})
		})
		this.socket.on('notify:unread_count', () => {
			// после выхода без перезагрузки сокет ещё жив, а запрос без токена очистит localStorage
			const current = TokenService.getUserObj()
			if(!TokenService.getAccessToken() || !current || current.id !== this.userId) {
				this.disconnect()
				return
			}
			onUnread()
		})
	},

	disconnect() {
		if(this.socket) {
			this.socket.disconnect()
		}
		this.socket = null
		this.userId = null
	}
}

export {RtService}
